"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KeyAnswerStatus = exports.KeyAnswer = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactSvg = require("react-svg");
var _getPrefixCls = require("../../utils/getPrefixCls");
var _Popup = require("../Popup");
var _RichText = require("../RichText");
var _resizeObserver = require("@juggle/resize-observer");
var _useTracking3 = require("../../hooks/useTracking");
var _key_answer_arrow = _interopRequireDefault(require("../../assets/images/key_answer_arrow.svg"));
var _warn_circle = _interopRequireDefault(require("../../assets/images/warn_circle.svg"));
var _clsx6 = _interopRequireDefault(require("clsx"));
var _constants = require("../../utils/tracking/constants");
var _uiOptimisationRecommenderRightArrow = _interopRequireDefault(require("../../assets/images/ui-optimisation-recommender-right-arrow.svg"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var KeyAnswerStatus;
exports.KeyAnswerStatus = KeyAnswerStatus;
(function (KeyAnswerStatus) {
  KeyAnswerStatus["LOADING"] = "LOADING";
  KeyAnswerStatus["ERROR"] = "ERROR";
  KeyAnswerStatus["FINISH"] = "FINISH";
})(KeyAnswerStatus || (exports.KeyAnswerStatus = KeyAnswerStatus = {}));
var FAQList = function FAQList(props) {
  var PREFIX = props.PREFIX,
    faqTitle = props.faqTitle,
    faqIntentList = props.faqIntentList,
    onClickFaq = props.onClickFaq,
    disabledFaq = props.disabledFaq,
    _props$isInDetail = props.isInDetail,
    isInDetail = _props$isInDetail === void 0 ? false : _props$isInDetail,
    useUIOptimisationRecommender = props.useUIOptimisationRecommender;
  var renderFAQItem = function renderFAQItem(faq, index) {
    // tracker
    var _useTracking = (0, _useTracking3.useTracking)({
        trackingData: props.trackingData,
        componentData: _objectSpread(_objectSpread({}, faq), {}, {
          location: index
        })
      }),
      trackingClick = _useTracking.trackingClick,
      trackingImpressionProps = _useTracking.trackingImpressionProps;
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      className: (0, _clsx6.default)("".concat(PREFIX, "-faq-item"), (0, _defineProperty2.default)({}, "".concat(PREFIX, "-faq-item__disabled"), disabledFaq)),
      onClick: function onClick() {
        // trackingClick && tracker.click(trackingClick);
        // 因为需要在点击时添加 next_chat_dialogue_id 这个 id 需要请求后才获得，所以把相应参数传回 C 端，那里触发点击上报
        onClickFaq === null || onClickFaq === void 0 ? void 0 : onClickFaq(faq, {
          trackingData: trackingClick === null || trackingClick === void 0 ? void 0 : trackingClick.data,
          isInDetail: isInDetail
        });
      }
    }, trackingImpressionProps), faq.text, useUIOptimisationRecommender ? /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
      src: _uiOptimisationRecommenderRightArrow.default,
      style: {
        width: 12,
        height: 12,
        marginLeft: 8
      }
    }) : null);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, faqIntentList !== null && faqIntentList !== void 0 && faqIntentList.length ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx6.default)("".concat(PREFIX, "-faq-container"), (0, _defineProperty2.default)({}, "".concat(PREFIX, "-faq-ui-optimisation-container"), useUIOptimisationRecommender))
  }, faqTitle && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-faq-title")
  }, faqTitle), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-faq-list")
  }, faqIntentList.map(renderFAQItem))) : null);
};
var KeyAnswer = function KeyAnswer(props) {
  var _props$componentTrack, _clsx5, _props$componentTrack2;
  var PREFIX = (0, _getPrefixCls.getPrefixCls)('key-answer');
  var _props$summaryMaxHeig = props.summaryMaxHeight,
    summaryMaxHeight = _props$summaryMaxHeig === void 0 ? 400 : _props$summaryMaxHeig,
    faqTitle = props.faqTitle,
    faqIntentList = props.faqIntentList,
    _props$viewMoreText = props.viewMoreText,
    viewMoreText = _props$viewMoreText === void 0 ? 'View More' : _props$viewMoreText,
    _props$unreadText = props.unreadText,
    unreadText = _props$unreadText === void 0 ? 'Unread' : _props$unreadText,
    _props$isAutoAdapt = props.isAutoAdapt,
    isAutoAdapt = _props$isAutoAdapt === void 0 ? false : _props$isAutoAdapt,
    _props$isScrollToUnre = props.isScrollToUnread,
    isScrollToUnread = _props$isScrollToUnre === void 0 ? false : _props$isScrollToUnre,
    disabledFaq = props.disabledFaq,
    loadKeyAnswer = props.loadKeyAnswer,
    _props$failToLoadText = props.failToLoadText,
    failToLoadText = _props$failToLoadText === void 0 ? 'Fail to load article due to server error.' : _props$failToLoadText,
    _props$status = props.status,
    status = _props$status === void 0 ? KeyAnswerStatus.FINISH : _props$status,
    _props$summary = props.summary,
    summary = _props$summary === void 0 ? '' : _props$summary,
    _props$supportingMess = props.supportingMessage,
    supportingMessage = _props$supportingMess === void 0 ? '' : _props$supportingMess,
    useUIOptimisationRecommender = props.useUIOptimisationRecommender,
    isUIOptimisationAccordion = props.isUIOptimisationAccordion,
    isUIOptimisationButton = props.isUIOptimisationButton,
    isUIOptimisationTable = props.isUIOptimisationTable,
    popupClassName = props.popupClassName; // const formatSummary = formatHtml(summary);

  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    exceededMaxHeight = _useState2[0],
    setExceededMaxHeight = _useState2[1];
  var _useState3 = (0, _react.useState)({
      index: 0
    }),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    unreadObj = _useState4[0],
    setUnreadObj = _useState4[1]; // const [uiOptimisationAccordionOptions, setUIOptimisationAccordionOptions] = useState<RichTextProps['uiOptimisationAccordionOptions']>();

  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    showPopup = _useState6[0],
    setShowPopup = _useState6[1];
  var summaryRef = (0, _react.useRef)(null);
  var trackClosePopupRef = (0, _react.useRef)({
    startTime: new Date(),
    articleScrolls: 0,
    articleScrollToEnd: false
  });
  var _ref = props.componentTrackingData || {},
    keyAnswerTracking = _ref.keyAnswer,
    closePopupTracking = _ref.closePopup;
  var _useTracking2 = (0, _useTracking3.useTracking)({
      trackingData: keyAnswerTracking
    }),
    tracker = _useTracking2.tracker,
    trackingClick = _useTracking2.trackingClick,
    trackingImpressionProps = _useTracking2.trackingImpressionProps;
  var changeTrackClosePopupData = function changeTrackClosePopupData(data) {
    var oldTrackingData = trackClosePopupRef.current;
    trackClosePopupRef.current = _objectSpread(_objectSpread({}, oldTrackingData || {}), data || {});
  };
  var onClickFaq = function onClickFaq(faq, option) {
    var _props$onClickFaq;
    if (disabledFaq) {
      var _props$onClickDisable;
      (_props$onClickDisable = props.onClickDisabledFaq) === null || _props$onClickDisable === void 0 ? void 0 : _props$onClickDisable.call(props, faq);
      return;
    }
    if (showPopup) {
      setShowPopup(false);
    }
    (_props$onClickFaq = props.onClickFaq) === null || _props$onClickFaq === void 0 ? void 0 : _props$onClickFaq.call(props, faq, option);
  };
  var loadKeyAnswerContent = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (loadKeyAnswer) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              loadKeyAnswer === null || loadKeyAnswer === void 0 ? void 0 : loadKeyAnswer();
            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function loadKeyAnswerContent() {
      return _ref2.apply(this, arguments);
    };
  }();
  var onClickViewMore = function onClickViewMore() {
    trackingClick && tracker.click(trackingClick);
    changeTrackClosePopupData({
      startTime: new Date(),
      articleScrolls: 0,
      articleScrollToEnd: false
    });
    setShowPopup(true);
  };
  var onClosePopup = function onClosePopup() {
    setShowPopup(false);
    if (closePopupTracking) {
      var trackClosePopupData = trackClosePopupRef.current;
      if (!trackClosePopupData.startTime) {
        return;
      }
      closePopupTracking.data = _objectSpread(_objectSpread({}, closePopupTracking.trackingdataBasic || {}), {}, {
        view_duration: Math.floor((new Date().getTime() - trackClosePopupData.startTime.getTime()) / 1000),
        key_answer_scrolls: trackClosePopupData.articleScrolls,
        key_answer_scroll_to_end: trackClosePopupData.articleScrollToEnd ? 0 : 1
      });
      tracker.click(closePopupTracking);
    }
  };
  var scrollTo = function scrollTo(element, finalHeight, duration) {
    if (duration <= 0) {
      return;
    }
    var distance = finalHeight - element.scrollTop;
    var perTick = distance / duration * 10;
    setTimeout(function () {
      element.scrollTop = element.scrollTop + perTick;
      if (element.scrollTop === finalHeight) {
        return;
      }
      scrollTo(element, finalHeight, duration - 10);
    }, 0);
  };
  var isListWrapper = function isListWrapper(childElement) {
    return childElement.tagName.toLowerCase() === 'ol' || childElement.tagName.toLowerCase() === 'ul';
  }; // 针对summary预览内容，找出第一个超出已读区域的元素index

  var handleUnread = function handleUnread(richTextElement, gradientOffsetTop, defaultIndex) {
    var childElements = Array.from(richTextElement === null || richTextElement === void 0 ? void 0 : richTextElement.children);
    if (!childElements.length) {
      return;
    } // 如果summary高度没有超出最大高度,unread标签加在末尾

    if (gradientOffsetTop === 0) {
      setUnreadObj({
        index: (childElements === null || childElements === void 0 ? void 0 : childElements.length) - 1
      });
      return;
    }
    for (var i = 0; i < childElements.length; i++) {
      var childElement = childElements[i]; // 判断子元素底部和父元素顶部之间的距离

      var distance = childElement.offsetHeight + childElement.offsetTop; // 已读内容高度是指白色渐变顶部距离父元素顶部的距离

      if (distance > gradientOffsetTop) {
        // 如果第一个超出已读部分的刚好是ol/ul标签，需要再深入一层判断其中具体的子元素
        if (isListWrapper(childElement)) {
          handleUnread(childElement, gradientOffsetTop, i);
        } else {
          // 其他元素直接获得index
          setUnreadObj({
            index: defaultIndex !== undefined ? defaultIndex : i,
            listIndex: defaultIndex !== undefined ? i : undefined
          });
        }
        break;
      }
    }
  }; // 添加unread分割线

  var addUnread = function addUnread(exceededMaxHeight, richTextElement, scrollElement, index, listWrapperOffsetTop) {
    var childElements = Array.from(richTextElement.children);
    var childElement = childElements.at(index);
    if (childElement && isListWrapper(childElement) && unreadObj.listIndex !== undefined) {
      var _childElement$parentN;

      // 创建一个position:relative的div包裹ol标签, 便于unread分割线使用absolute
      var olWrapperElement = document.createElement('div');
      olWrapperElement.style.position = 'relative';
      (_childElement$parentN = childElement.parentNode) === null || _childElement$parentN === void 0 ? void 0 : _childElement$parentN.insertBefore(olWrapperElement, childElement);
      olWrapperElement.appendChild(childElement);
      addUnread(exceededMaxHeight, childElement, scrollElement, unreadObj.listIndex || 0, olWrapperElement.offsetTop);
      return;
    }
    if (childElement && (index > 0 || listWrapperOffsetTop || !exceededMaxHeight)) {
      // 添加unread分割线
      var unreadMarker = "\n      <div style=\"height: 48px; padding: 4px 0;\" class=\"ChatbotUI-popup-content-unread\">\n          <div style=\"".concat(unreadObj.listIndex !== undefined ? 'position: absolute;left: 0;right: 0;' : '', "padding-top: 12px;display: flex;align-items: center;\">\n            <div style=\"flex-grow: 1; border-top: 0.5px solid rgba(0, 0, 0, 0.09);\"></div>\n            <div style=\"font-size: 14px !important;font-weight: 500;line-height: 16px;color: rgba(0, 0, 0, 0.54);padding: 0 8px\">").concat(unreadText, "</div>\n            <div style=\"flex-grow: 1; border-top: 0.5px solid rgba(0, 0, 0, 0.09);\"></div>\n          </div>\n      </div>");
      var childNodes = childElement.childNodes; // 如果内容只有一个<br />换行, unread分割线需要加在换行的下方, 其他情况加在上方

      var hasOnlyBrChild = childNodes.length === 1 && childNodes[0] instanceof HTMLBRElement;
      childElement.insertAdjacentHTML(hasOnlyBrChild || !exceededMaxHeight ? 'afterend' : 'beforebegin', unreadMarker);
      var unreadLineOffsetTop = scrollElement.querySelector('.ChatbotUI-popup-content-unread').offsetTop; // 滚动距离是unread分割线距离弹出框顶部的距离，需要去掉弹出框的marginTop值

      var scrollElementMarginTop = parseFloat(getComputedStyle(scrollElement).marginTop); // 由于ol/ul标签外层有包裹一个div, unreadLineOffsetTop是unread分隔线距离该div的距离，需要加上 listWrapperOffsetTop 得到真实滚动距离

      var scrollHeight = unreadLineOffsetTop - scrollElementMarginTop + (listWrapperOffsetTop || 0);
      setTimeout(function () {
        scrollTo(scrollElement, scrollHeight, 400);
      }, 900);
    }
  };
  var getUIOptimisationAccordionOptions = function getUIOptimisationAccordionOptions(html, expand, haveClick) {
    if (isUIOptimisationAccordion) {
      return {
        html: html,
        expand: expand,
        isUIOptimisationAccordion: isUIOptimisationAccordion,
        onUIOptimisationAccordionClick: haveClick ? function () {
          // accordionItemIndex?: number, accordionIndex?: number
          // setUIOptimisationAccordionOptions({ accordionItemIndex, accordionIndex });
          setShowPopup(true);
        } : undefined
      };
    } else {
      return undefined;
    }
  };
  (0, _react.useEffect)(function () {
    if (status === KeyAnswerStatus.LOADING) {
      loadKeyAnswerContent();
    }
  }, [status]);
  (0, _react.useEffect)(function () {
    var ResizeObserver = window.ResizeObserver || _resizeObserver.ResizeObserver;
    var resizeObserver = new ResizeObserver(function (entries) {
      var _iterator = _createForOfIteratorHelper(entries),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var entry = _step.value;
          var contentRect = entry.contentRect;
          var richTextElement = summaryRef.current.querySelector('.ChatbotUI-rich-text-content');
          if (contentRect.height >= summaryMaxHeight) {
            var _querySelector;
            setExceededMaxHeight(true); // 白色渐变顶部距离父元素顶部的距离

            var gradientOffsetTop = (_querySelector = summaryRef.current.querySelector('.ChatbotUI-key-answer-gradient')) === null || _querySelector === void 0 ? void 0 : _querySelector.offsetTop; // 在预览状态下确认已读区域

            isScrollToUnread && handleUnread(richTextElement, gradientOffsetTop);
          } else {
            setExceededMaxHeight(false); // 如果summary高度没有超出最大高度,unread标签加在末尾

            isScrollToUnread && handleUnread(richTextElement, 0);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    summaryRef.current && resizeObserver.observe(summaryRef.current);
    return function () {
      resizeObserver.disconnect();
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (showPopup && isScrollToUnread) {
      setTimeout(function () {
        var scrollElement = document.querySelector('.ChatbotUI-modal-popup-content');
        var richTextElement = scrollElement.querySelector('.ChatbotUI-rich-text-content');
        addUnread(exceededMaxHeight, richTextElement, scrollElement, unreadObj.index);
      }, 100);
    }
  }, [showPopup]);
  if (status === KeyAnswerStatus.LOADING) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: PREFIX,
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(PREFIX, "__loading")
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(PREFIX, "__loading")
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(PREFIX, "__loading")
    }));
  }
  if (status === KeyAnswerStatus.ERROR) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: PREFIX
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(PREFIX, "__error")
    }, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
      src: _warn_circle.default,
      className: "".concat(PREFIX, "-prompt-icon")
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "".concat(PREFIX, "-prompt-text")
    }, failToLoadText)));
  }
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: PREFIX
  }, trackingImpressionProps), /*#__PURE__*/_react.default.createElement("div", {
    ref: summaryRef,
    className: "".concat(PREFIX, "-summary"),
    style: {
      maxHeight: summaryMaxHeight
    }
  }, /*#__PURE__*/_react.default.createElement(_RichText.RichText, {
    content: summary,
    articleContentTrackingData: closePopupTracking !== null && closePopupTracking !== void 0 && closePopupTracking.trackingdataBasic ? _objectSpread(_objectSpread({}, closePopupTracking === null || closePopupTracking === void 0 ? void 0 : closePopupTracking.trackingdataBasic), {}, {
      trackingsection: _constants.TRACKING_SECTION.keyAnswerDetail
    }) : undefined,
    uiOptimisationAccordionOptions: getUIOptimisationAccordionOptions(summary, false, true),
    isUIOptimisationButton: isUIOptimisationButton
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx6.default)("".concat(PREFIX, "-gradient"), (0, _defineProperty2.default)({}, "".concat(PREFIX, "-gradient__show"), exceededMaxHeight))
  })), exceededMaxHeight || supportingMessage ? /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-btn"),
    onClick: onClickViewMore
  }, /*#__PURE__*/_react.default.createElement("span", null, viewMoreText), /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
    src: _key_answer_arrow.default,
    className: "".concat(PREFIX, "-arrow")
  })) : /*#__PURE__*/_react.default.createElement(FAQList, {
    disabledFaq: disabledFaq,
    PREFIX: PREFIX,
    faqTitle: faqTitle,
    faqIntentList: faqIntentList,
    onClickFaq: onClickFaq,
    trackingData: (_props$componentTrack = props.componentTrackingData) === null || _props$componentTrack === void 0 ? void 0 : _props$componentTrack.faq,
    useUIOptimisationRecommender: useUIOptimisationRecommender
  }), /*#__PURE__*/_react.default.createElement(_Popup.Popup, {
    showCloseIcon: true,
    title: "",
    className: "".concat(PREFIX, "-popup ").concat(popupClassName || ''),
    contentContainerClassName: (0, _clsx6.default)("".concat(PREFIX, "-popup-content"), (0, _defineProperty2.default)({}, "".concat(PREFIX, "-popup-content__autoAdaptHeight"), isAutoAdapt)),
    active: showPopup,
    onClose: onClosePopup
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-detail")
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_RichText.RichText, {
    content: summary,
    articleContentTrackingData: closePopupTracking !== null && closePopupTracking !== void 0 && closePopupTracking.trackingdataBasic ? _objectSpread(_objectSpread({}, closePopupTracking === null || closePopupTracking === void 0 ? void 0 : closePopupTracking.trackingdataBasic), {}, {
      trackingsection: _constants.TRACKING_SECTION.keyAnswerDetail
    }) : undefined,
    onClose: onClosePopup,
    uiOptimisationAccordionOptions: getUIOptimisationAccordionOptions(summary, true),
    isUIOptimisationButton: isUIOptimisationButton
  }), supportingMessage && /*#__PURE__*/_react.default.createElement(_RichText.RichText, {
    className: (0, _clsx6.default)("".concat(PREFIX, "-supporting-message"), (_clsx5 = {}, (0, _defineProperty2.default)(_clsx5, "".concat(PREFIX, "-supporting-message__bottom"), !faqIntentList), (0, _defineProperty2.default)(_clsx5, "".concat(PREFIX, "-supporting-message__noExceeded"), !exceededMaxHeight), _clsx5)),
    content: supportingMessage,
    articleContentTrackingData: closePopupTracking !== null && closePopupTracking !== void 0 && closePopupTracking.trackingdataBasic ? _objectSpread(_objectSpread({}, closePopupTracking === null || closePopupTracking === void 0 ? void 0 : closePopupTracking.trackingdataBasic), {}, {
      trackingsection: _constants.TRACKING_SECTION.keyAnswerDetail
    }) : undefined,
    changeTrackCloseArticleContentData: changeTrackClosePopupData,
    onClose: onClosePopup,
    uiOptimisationAccordionOptions: getUIOptimisationAccordionOptions(supportingMessage, true),
    isUIOptimisationButton: isUIOptimisationButton,
    isUIOptimisationTableModal: isUIOptimisationTable
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-detail-content-faq")
  }, /*#__PURE__*/_react.default.createElement(FAQList, {
    disabledFaq: disabledFaq,
    PREFIX: PREFIX,
    faqTitle: faqTitle,
    faqIntentList: faqIntentList,
    onClickFaq: onClickFaq,
    trackingData: (_props$componentTrack2 = props.componentTrackingData) === null || _props$componentTrack2 === void 0 ? void 0 : _props$componentTrack2.faqInDetail,
    isInDetail: true,
    useUIOptimisationRecommender: useUIOptimisationRecommender
  }))))));
};
exports.KeyAnswer = KeyAnswer;